import i18n from '@/main';

export const statusElegibilidade = {
    ELIGIBLE: {
        class: 'status-sucess',
        icon: 'mdi mdi-check-circle-outline',
        status: i18n.t(
            'relatorioExportacao.elegibilidade.elegivel'
        )
    },
    NOT_ELIGIBLE: {
        class: 'status-danger',
        icon: 'mdi mdi-close-circle-outline',
        status: i18n.t(
            'relatorioExportacao.elegibilidade.inelegivel'
        )
    },
    UNDEFINED: {
        class: 'default',
        icon: 'mdi mdi-help-circle-outline',
        status: '-'
    },
    WARNING: {
        class: 'status-laranja',
        icon: 'mdi mdi-alert-circle-outline',
        status: i18n.t(
            'relatorioExportacao.elegibilidade.alerta'
        )
    }
};

export function obterStatus(status) {
    if (!statusElegibilidade[status]) {
        const undefinedStatus = statusElegibilidade.UNDEFINED;
        return {
            class: undefinedStatus.class,
            icon: undefinedStatus.icon,
            status: status || '-'
        };
    }

    return statusElegibilidade[status];
}
